// extracted by mini-css-extract-plugin
export var orderDetails = "_j7-2";
export var orderImage = "_j7-1";
export var orderMeta = "_j7-3";
export var orderSummary = "_j7-0";
export var rightArrow = "_j7-4";